<template>
    <page :busy="busy">
        <b-container fluid v-if="groupPermissions">
            <b-row>
                <b-col lg="4" md="8" sm="12">
                    <h5 class="mb-4 mt-2">Access Inbox Group Permissions</h5>
                    <b-row>
                        <b-col :md="12">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>Group Name</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="groupPermission in groupPermissions" :key="groupPermission.id">
                                        <td>{{ groupPermission.group_name }}</td>
                                        <td style="text-align: right;">
                                            <form-switch
                                                v-model="groupPermission.mode"
                                                @change="updateAllowed(groupPermission)"
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-container>
    </page>
</template>

<script>
    import api from '../../../api';
    import { mapGetters } from 'vuex';
    import { formatResponseError } from '../../../utils/api';
    import {
        CHAT_SETTINGS_GROUPS_PERMISSIONS_LIST_ENDPOINT,
        CHAT_SETTINGS_GROUPS_PERMISSIONS_DETAIL_ENDPOINT,
    } from '../../../endpoints';
    import FormSwitch from '../../generic/form-switch/form-switch.vue';
    import Page from '../../generic/page/page.vue';
    export default {
        components: {
            FormSwitch,
            Page,
        },
        data() {
            return {
                busy: false,
                groupPermissions: null,
            };
        },
        mounted() {
            this.fetchAllData();
        },
        computed: {
            ...mapGetters('header', ['userSubscriberId']),
        },
        methods: {
            async updateAllowed(groupPermission) {
                try {
                    this.busy = true;
                    await api.patch(CHAT_SETTINGS_GROUPS_PERMISSIONS_DETAIL_ENDPOINT(groupPermission.id), {
                        mode: groupPermission.mode ? 'ALLOW' : 'DENY',
                    });
                    this.successToast({ text: 'Group permission successfully saved' });
                } catch (e) {
                    const { generic } = formatResponseError(e);
                    this.errorToast({ text: generic || 'Could not save group permission' });
                } finally {
                    this.busy = false;
                }
            },
            async fetchAllData() {
                this.busy = true;
                await this.fetchGroupPermissions();
                this.busy = false;
            },
            async fetchGroupPermissions() {
                try {
                    this.busy = true;
                    const { data } = await api.get(CHAT_SETTINGS_GROUPS_PERMISSIONS_LIST_ENDPOINT());
                    this.groupPermissions = data.map((groupPermission) => ({
                        ...groupPermission,
                        mode: groupPermission.mode === 'ALLOW',
                    }));
                } catch (e) {
                    const { generic } = formatResponseError(e);
                    this.errorToast({ text: generic || 'Could not fetch group permissions' });
                } finally {
                    this.busy = false;
                }
            },
        },
    };
</script>

<style scoped lang="scss">
    @import '~bootstrap/scss/_functions.scss';
    @import '~bootstrap/scss/_variables.scss';
    @import '~bootstrap/scss/mixins/_breakpoints.scss';
    :deep(*) {
        font-family: 'Lato', sans-serif !important;
    }
</style>
